import React, { useEffect, createElement, Component } from 'react';
import './index.css';
import { createRoot } from 'react-dom/client';
import { App } from './App';
// Componente wrapper para verificar Meta Pixel
function AppWithPixelCheck() {
  useEffect(() => {
    // Verificar si el Meta Pixel está cargado correctamente
    const checkPixel = () => {
      if (typeof window !== 'undefined') {
        if (typeof window.fbq === 'function') {
          console.log('Meta Pixel detectado en AppWithPixelCheck');
          // Intentar enviar un evento de prueba
          try {
            window.fbq('trackCustom', 'AppInitialized', {
              timestamp: new Date().toISOString()
            });
            console.log('Evento de prueba enviado correctamente');
          } catch (e) {
            console.error('Error al enviar evento de prueba:', e);
          }
        } else {
          console.warn('Meta Pixel no detectado en AppWithPixelCheck');
          // Intentar cargar el pixel manualmente
          const script = document.createElement('script');
          script.innerHTML = `
            !function(f,b,e,v,n,t,s)
            {if(f.fbq)return;n=f.fbq=function(){n.callMethod?
            n.callMethod.apply(n,arguments):n.queue.push(arguments)};
            if(!f._fbq)f._fbq=n;n.push=n;n.loaded=!0;n.version='2.0';
            n.queue=[];t=b.createElement(e);t.async=!0;
            t.src=v;s=b.getElementsByTagName(e)[0];
            s.parentNode.insertBefore(t,s)}(window, document,'script',
            'https://connect.facebook.net/en_US/fbevents.js');
            fbq('init', '773967181920012');
            fbq('track', 'PageView');
          `;
          document.head.appendChild(script);
          // También agregar la imagen noscript como respaldo
          const noscript = document.createElement('noscript');
          const img = document.createElement('img');
          img.height = 1;
          img.width = 1;
          img.style.display = 'none';
          img.src = 'https://www.facebook.com/tr?id=773967181920012&ev=PageView&noscript=1';
          noscript.appendChild(img);
          document.head.appendChild(noscript);
        }
      }
    };
    // Verificar inmediatamente y luego cada 5 segundos
    checkPixel();
    const interval = setInterval(checkPixel, 5000);
    return () => clearInterval(interval);
  }, []);
  return <App data-id="element-486" />;
}
// Función para asegurar que la app se carga correctamente
function initializeApp() {
  try {
    const container = document.getElementById('root');
    // Si el contenedor no existe, lo creamos
    if (!container) {
      console.log('Creando elemento root');
      const newContainer = document.createElement('div');
      newContainer.id = 'root';
      document.body.appendChild(newContainer);
      const root = createRoot(newContainer);
      root.render(<React.StrictMode data-id="element-487">
          <AppWithPixelCheck data-id="element-488" />
        </React.StrictMode>);
    } else {
      console.log('Usando elemento root existente');
      const root = createRoot(container);
      root.render(<React.StrictMode data-id="element-489">
          <AppWithPixelCheck data-id="element-490" />
        </React.StrictMode>);
    }
    // Verificar si hay bloqueadores de anuncios
    setTimeout(() => {
      const testAd = document.createElement('div');
      testAd.innerHTML = '&nbsp;';
      testAd.className = 'adsbox';
      document.body.appendChild(testAd);
      setTimeout(() => {
        if (testAd.offsetHeight === 0) {
          console.warn('Posible bloqueador de anuncios detectado en initializeApp');
          // Intentar implementar solución alternativa
          const directPixel = new Image(1, 1);
          directPixel.src = 'https://www.facebook.com/tr?id=773967181920012&ev=PageView&noscript=1&cd[adBlockerDetected]=true';
          document.body.appendChild(directPixel);
        }
        document.body.removeChild(testAd);
      }, 100);
    }, 2000);
  } catch (error) {
    console.error('Error al inicializar la aplicación:', error);
    // Mostrar mensaje de error en la página
    const errorMessage = document.createElement('div');
    errorMessage.style.color = 'white';
    errorMessage.style.background = 'red';
    errorMessage.style.padding = '20px';
    errorMessage.style.margin = '20px';
    errorMessage.style.borderRadius = '5px';
    errorMessage.textContent = 'Hubo un error al cargar la página. Por favor, intenta recargar.';
    document.body.appendChild(errorMessage);
  }
}
// Iniciar la aplicación cuando el DOM esté listo
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initializeApp);
} else {
  initializeApp();
}